import { Routes } from '@angular/router';
import { authGuard } from 'src/app/_core/guards/auth.guard';
import { PUBLIC_ROUTES } from 'src/app/routes/public/public.routes';
import { createLanguageMatcher } from 'src/app/_core/utils/helpers/route.matchers';

export const APP_ROUTES: Routes = [
  {
    path: 'preview',
    children: PUBLIC_ROUTES,
  },
  {
    matcher: createLanguageMatcher({ account: 'konto' }, { de: 'konto' }),
    canMatch: [authGuard({})],
    loadChildren: () =>
      import('./routes/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'en',
    loadChildren: () =>
      import('./routes/public/public.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: 'de',
    loadChildren: () =>
      import('./routes/public/public.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: '',
    loadChildren: () =>
      import('./routes/public/public.routes').then((m) => m.PUBLIC_ROUTES),
  },
  { path: '**', redirectTo: '' },
];
